import { Component, EventEmitter, Input, Output } from '@angular/core';

import { SharedModule } from '../../_shared/shared.module';
import { AbilityService } from '../../_shared/services/ability.service';
import { DataService } from '../../_shared/services/data.service';
import { UtilService } from '../../_shared/services/util.service';

import { Location } from '../shared/location.model';
import { LocationService } from '../shared/location.service';

@Component({
  selector: 'app-location-list',
  templateUrl: './location-list.component.html',
  standalone: true,
  imports: [SharedModule],
})
export class LocationListComponent {
  @Input() locations: Location[];
  @Input() meta;
  @Input() loadingLocations: boolean;
  @Input() defaultLanguage;

  @Output() private selectedLocation = new EventEmitter<{
    location: Location;
    mode: string;
  }>();

  permissions = {
    canShow: this.abilityService.can('show_location_accountadmin'),
    canUpdate: this.abilityService.can('update_location_accountadmin'),
    canDestroy: this.abilityService.can('destroy_location_accountadmin'),
  };

  filterCriteria = this.locationService.getFilterCriteria();

  constructor(
    private locationService: LocationService,
    private abilityService: AbilityService,
    private dataService: DataService,
    public utilService: UtilService
  ) {}

  reloadLocations() {
    this.filterCriteria = this.locationService.getFilterCriteria();

    this.getLocations();
  }

  // Referenced from app-search-text-input
  onSearched({ field, value }) {
    this.filterLocations(field, value);
  }

  filterLocations(field, value) {
    this.filterCriteria = this.utilService.setFilterCriteria(this.filterCriteria, field, value);

    this.getLocations();
  }

  clearSearchForm() {
    this.reloadLocations();
  }

  // Referenced from app-sort-by
  onSorted({ sortBy, sortDir }) {
    this.filterCriteria.page = 1;
    this.filterCriteria.sortDir = sortDir;
    this.filterCriteria.sortedBy = sortBy;

    this.getLocations();
  }

  // Referenced from app-table-footer
  onSelectedPage({ page, offset }) {
    this.filterCriteria.page = page;
    this.filterCriteria.offset = offset;

    this.getLocations();
  }

  selectLocation(location: Location, mode = '') {
    if (!this.permissions.canShow) return;

    this.selectedLocation.emit({ location, mode });
  }

  changeLocationStatus(location: Location) {
    let successCallback = () => {
      this.utilService.changeItemRowStyle(location.id);
    };

    this.dataService.changeItemStatus('locations', location, successCallback);
  }

  deleteLocation(location: Location) {
    let successCallback = () => {
      this.getLocations();
    };

    const params = {
      title: 'DELETE_LOCATION',
      message: 'SURE_TO_DELETE_LOCATION',
      reason: 'DELETE_ITEM_REASON',
      requireConfirmation: true,
      successMsg: 'LOCATION_DELETED',
    };

    this.dataService.deleteItem('locations', location, successCallback, params);
  }

  private getLocations() {
    this.filterCriteria.lang = this.defaultLanguage.lang;

    this.loadingLocations = true;
    this.locationService.getLocations(this.filterCriteria).subscribe((response) => {
      this.locations = response.data;
      this.meta = response.meta;

      this.loadingLocations = false;
    });
  }
}
